!function () {

    var SELECTOR_FLOWER = '[data-rel="flower"]';
    var INDICATOR_FLOWER = 'data-rel';

    /**
     * Draws a new flower.
     *
     * @param paperWrapper The element the SVG will be drawn in. The width of the element defines the size of the SVG.
     * @param interactive If interactive mode is enabled the leafs can be dragged.
     * @param ratingWrapperPrefix The prefix of the rating wrapper.
     */
    var Flower = function (paperWrapper, interactive, ratingWrapperPrefix) {

        // Constants.
        var ANIMATION_DURATION = 200;
        var LEAF_MINIMUM_VALUE = 1;
        var LEAF_MAXIMUM_VALUE = 3;
        var LEAFS_COUNT = 5;
        var OFFSET_ROTATION = 90;
        var DEGREES_OF_FULL_CIRCLE = 360;
        var SCALING_FACTOR_SIZE = 8;
        var SCALING_FACTOR_OFFSET = 100;
        var OPACITY_VISIBLE = 1;
        var OPACITY_INVISIBLE = 0;
        var VISIBLE_LEAFS_MINIMUM = 1;
        var DISABLED_OPACITY = 0.4;
        var FLOWER_SIZE_FACTOR = 0.8;
        var DISABLED_COLOR = '#CCCCCC';
        var TOOLTIP_COLOR = '#333333';
        var DISABLED_POSTFIX = '-disabled';
        var CURSOR = 'pointer';
        var LEAF_OPTIONAL = __('INTERFACE.HEADER.RANDOM');
        var LEAF_RATINGS = [
            __('INTERFACE.HEADER.NOT'),
            __('INTERFACE.HEADER.BARELY'),
            __('INTERFACE.HEADER.A_BIT'),
            __('INTERFACE.HEADER.VERY')
        ];
        var LEAF_NAMES = {
            sour:       __('GLOBAL.SOUR'),
            savoury:    __('GLOBAL.SAVOURY'),
            sweet:      __('GLOBAL.SWEET'),
            creamy:     __('GLOBAL.MUSHY'),
            crunchy:    __('GLOBAL.CRISPY')
        };

        // Properties.
        var visibilityCounter = 5;
        var leafs = {};
        var callbacks = [];

        // Initialisation Functions.
        var createLeafConfiguration = function (currentIndex, name, primaryColor, secondaryColor, offsetX, offsetY) {
            var rotation = DEGREES_OF_FULL_CIRCLE / LEAFS_COUNT;
            return {
                name: name,
                primaryColor: primaryColor,
                secondaryColor: secondaryColor,
                rotation: OFFSET_ROTATION + (rotation * currentIndex),
                offsetX: offsetX,
                offsetY: offsetY,
                subLeafs: []
            };
        };

        // Initial Leaf Configurations including coordinates, positions and colors.
        var sweetLeafConfiguration = createLeafConfiguration(0, 'sweet', '#F9DFE5', '#F20D45', 0, -1);
        var creamyLeafConfiguration = createLeafConfiguration(1, 'creamy', '#FFF0D4', '#FBB900', -0.5, -0.25);
        var crunchyLeafConfiguration = createLeafConfiguration(2, 'crunchy', '#C3D9DF', '#006AFF', -0.5, 0.5);
        var savouryLeafConfiguration = createLeafConfiguration(3, 'savoury', '#FCE4D7', '#C2012F', 0.5, 0.5);
        var sourLeafConfiguration = createLeafConfiguration(4, 'sour', '#EAF2D7', '#A9C938', 0.5, -0.25);

        // Dynamic configuration of leafs, initial loaded from form data (it will be not updated!).
        var configuration = App.Utilities.Serialize.formToObject(document.getElementById(paperWrapper.attr('id') + '-form'));

        var size = paperWrapper.width();

        var paper = Raphael(paperWrapper.attr('id'), size, size);

        /**
         * Draws a single subleaf and creates the action handlers of the subleaf.
         *
         * @param leaf The configuration of the leaf.
         * @param currentIndex The current index of the subleaf.
         */
        var drawLeaf = function (leaf , currentIndex) {

            // Locale variables
            var resizeFactor = currentIndex / LEAF_MAXIMUM_VALUE;
            var paperFlowerSize = paper.width * FLOWER_SIZE_FACTOR;
            var x = (paperFlowerSize / 2) + (paper.width * ((1.0 - FLOWER_SIZE_FACTOR) / 2));
            var y = (paperFlowerSize / 2);
            var offsetResizeFactor = paper.width / SCALING_FACTOR_OFFSET;
            var offsetX = leaf.offsetX * offsetResizeFactor;
            var offsetY = leaf.offsetY * offsetResizeFactor;
            var angle = leaf.rotation || 0;
            var bb = {
                x: x, y: y,
                height: paperFlowerSize / SCALING_FACTOR_SIZE,
                width: paperFlowerSize / SCALING_FACTOR_SIZE
            };

            // Determine size, coloring and shape of the leaf.
            // The shape is defined by a line to an arc, the arc itself and an second line from the arcs end point to the
            // start point of the shape. The optimal values for drawing the shape are fine tuned by trail and error =)
            var cursor = { 'cursor': CURSOR };
            var color = (currentIndex > configuration[leaf.name]) ? leaf.primaryColor : leaf.secondaryColor;
            x = ((typeof(x) == 'number') ? x : (bb.width / 2)) + offsetX;
            y = ((typeof(y) == 'number') ? y : (bb.y + bb.height / 2)) + offsetY;
            var size = (Math.max(bb.width, bb.height) + Math.min(bb.width, bb.height)) * resizeFactor;
            var leafPath = paper.path([
                'M', x, y,
                'l', size, 0,
                'A', (size * 0.68), (size * 0.66), 1, 1, 0, (x + (size * 0.28)), (y - (size * 0.82)),
                'z'
            ]).attr({fill: color, stroke: 'none'}).rotate(35 - angle, x, y);
            leafPath.attr(cursor);

            // Add mouse handlers for dragging and clicks.
            if (interactive) {

                // Intialize local variables.
                leaf.isActiveMode = false;
                $(ratingWrapperPrefix + leaf.name).text(LEAF_RATINGS[configuration[leaf.name]]);

                /**
                 * Enable the active mode in order to make the execution of the hover handler possible.
                 */
                var mouseDown = function () {
                    leaf.isActiveMode = true;
                };

                /**
                 * Disable the active mode again.
                 */
                var mouseUp = function () {
                    leaf.isActiveMode = false;
                };

                /**
                 * If the user hovers a leaf an the mouse is down (active mode is enabled) the flower will be updated.
                 * Otherwise nothing happens. If the flower is disabled it has to be enabled before the action can take place.
                 */
                var hover = function () {
                    if (!leaf.isActiveMode) return;
                    if (configuration[leaf.name + DISABLED_POSTFIX]) return;
                    configuration[leaf.name] = currentIndex;
                    $(ratingWrapperPrefix + leaf.name).text(LEAF_RATINGS[configuration[leaf.name]]);
                    for (var i = 0; i < leaf.subLeafs.length; ++i) {
                        leaf.subLeafs[i].attr({ 'fill' : ((i < currentIndex) ? leaf.secondaryColor : leaf.primaryColor) });
                    }
                    for (var i = 0; i < callbacks.length; ++i) {
                        callbacks[i]();
                    }
                };

                /**
                 * The click handler enabled the active mode, triggers the hover handler instead of the user and disables the active mode again.
                 */
                var click = function () {
                    leaf.isActiveMode = true;
                    hover();
                    leaf.isActiveMode = false;
                };

                // Install all handlers for the subleaf. Maybe we need additional touch handlers here in future.
                leafPath.mousedown(mouseDown);
                leafPath.mouseup(mouseUp);
                leafPath.hover(hover);
                leafPath.click(click);
            } else {

                // Attach a tooltip to the leafs that shows the current (interactive) or selected (normal mode) intensity.
                var tooltipX = x;
                var tooltipY = paperFlowerSize + (paperFlowerSize * ((1.0 - FLOWER_SIZE_FACTOR) / 2));
                var tooltipText = (LEAF_RATINGS[configuration[leaf.name]] + '\n' + LEAF_NAMES[leaf.name]).toUpperCase();
                var tooltip = paper.text(tooltipX, tooltipY, tooltipText);
                tooltip.attr({ 'fill' : leaf.secondaryColor });
                leafPath.tooltip(tooltip);
            }

            // Remember the subleaf.
            leaf.subLeafs[currentIndex - 1] = leafPath;
            leafs[leaf.name] = leaf;
        };

        /**
         * Shows/Enables a leaf of the flower.
         *
         * @param leafName The name of the leaf to enable.
         */
        this.show = function (leafName) {
            var leaf = leafs[leafName];
            var subLeafs = leaf.subLeafs;
            for (var i = 0; i < subLeafs.length; ++i) {
                subLeafs[i].animate({ fill : ((i < configuration[leaf.name]) ? leaf.secondaryColor : leaf.primaryColor), opacity: OPACITY_VISIBLE }, ANIMATION_DURATION);
            }
            $(ratingWrapperPrefix + leaf.name).text(LEAF_RATINGS[configuration[leaf.name]]);
            delete configuration[leaf.name + DISABLED_POSTFIX];
            visibilityCounter++;
        };

        /**
         * Hides/Disables a leaf of the flower.
         *
         * @param leafName The name of the leaf to hide.
         * @returns {boolean} True if the leaf was hidden, false if too many leafs are already hidden
         */
        this.hide = function (leafName) {
            //if (visibilityCounter == VISIBLE_LEAFS_MINIMUM) return false;
            var leaf = leafs[leafName];
            var subLeafs = leaf.subLeafs;
            for (var i = 0; i < subLeafs.length; ++i) {
                subLeafs[i].animate({ fill : DISABLED_COLOR, opacity: DISABLED_OPACITY }, ANIMATION_DURATION);
            }
            $(ratingWrapperPrefix + leaf.name).text(LEAF_OPTIONAL.toUpperCase());
            configuration[leaf.name + DISABLED_POSTFIX] = true;
            visibilityCounter--;
            return true;
        };

        /**
         * Adds a callback handler that's executed if the flower changes.
         *
         * @param callback The callback function.
         */
        this.addCallback = function (callback) {
            callbacks.push(callback);
        };

        /**
         * Returns the configuration objects of the flower's leafs.
         *
         * @returns {{}}
         */
        this.getConfiguration = function () {
            return configuration;
        };

        // Draw the initial flower
        for (var currentLeaf = LEAF_MAXIMUM_VALUE; currentLeaf >= LEAF_MINIMUM_VALUE; --currentLeaf) {
            drawLeaf(sweetLeafConfiguration, currentLeaf);
            drawLeaf(creamyLeafConfiguration, currentLeaf);
            drawLeaf(crunchyLeafConfiguration, currentLeaf);
            drawLeaf(savouryLeafConfiguration, currentLeaf);
            drawLeaf(sourLeafConfiguration, currentLeaf);
        }

    };

    /**
     * Static method that triggers the parsing of flower forms to SVGs.
     */
    Flower.parse = function () {
        $(SELECTOR_FLOWER).each(
            function (index, element) {

                // Create the flower and remove the indicator for the parsing process.
                new Flower($(element), false);
                $(element).removeAttr(INDICATOR_FLOWER);
            }
        );
    };

    // TODO JSFace Class, js-prefixed classes instead of data-rel
    $(Flower.parse);
    $(document).ajaxComplete(Flower.parse);

    window.Flower = Flower;

} ();
